import Vue from 'vue';
import http from '../utils/http';

export default {
    state: {
        awareness: [],
        loyalty: [],
    },
    mutations: {
        loadAwareness(state, payload) {
			state.awareness = payload;
		},
        loadLoyalty(state, payload) {
			state.loyalty = payload;
		},
        addAwareness(state, payload) {
            let index = state.awareness.length
			Vue.set(state.awareness, index, payload)   
        },
        addLoyalty(state, payload) {
            let index = state.loyalty.length
			Vue.set(state.loyalty, index, payload)   
        },
        updateAwareness(state, payload) {
            const awar = state.awareness.find(item => item.id == payload.id)
            let index = state.awareness.indexOf(awar);
			Vue.set(state.awareness, index, { ...awar, ...payload })   
        },
        updateLoyalty(state, payload) {
            const awar = state.loyalty.find(item => item.id == payload.id)
            let index = state.loyalty.indexOf(awar);
			Vue.set(state.loyalty, index, { ...awar, ...payload })   
        },
        deleteAwareness(state, payload) {
            state.awareness =  state.awareness.filter(item => item.id !== payload)
        },
        deleteLoyalty(state, payload) {
            state.loyalty =  state.loyalty.filter(item => item.id !== payload)
        }
    },
    actions: {
        //fetch all trademarks awareness by game id & round
        async fetchAwareness({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/awareness/game/${payload.gameId}?round=${payload.round}`);
                if (result) {
                   const trademarks_awareness = await result.data 
                   commit('loadAwareness', trademarks_awareness)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        //fetch trademarks loyalty by game id & round
        async fetchLoyalty({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/loyalty/game/${payload.gameId}?round=${payload.round}`);
                
                if (result) {
                   const loyalty = await result.data 
                   commit('loadLoyalty', loyalty)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async addAwareness({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            let trademark = {}

            if (payload.trademark) {
                trademark = payload.trademark;
                delete payload.trademark;
            }

            try {
                const result = await http.post(`/awareness`, payload);
                
                if (result) {
                   const trademarks_awareness = await result.data;
                   
                   if (!trademarks_awareness.trademark) {
                    trademarks_awareness.trademark = trademark;
                   }
                    
                   commit('addAwareness', trademarks_awareness);
                }                              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async updateAwareness({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            try {
                await http.put(`/awareness/${payload.id}`, payload);
                commit('updateAwareness', payload);                             
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async addLoyalty({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            let segment = {};
            let trademark = {}

            if (payload.trademark) {
                trademark = payload.trademark;
                delete payload.trademark;
            }

            if (payload.segment) {
                segment = payload.segment
                delete payload.segment
            }

            try {
                const result = await http.post(`/loyalty`, payload);
                
                if (result) {
                   const trademarks_loyalty = await result.data;
                   trademarks_loyalty.segment = segment;
                   trademarks_loyalty.trademark = trademark;
                   
                   commit('addLoyalty', trademarks_loyalty);
                }                              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async updateLoyalty({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            try {
                await http.put(`/loyalty/${payload.id}`, payload);
                commit('updateLoyalty', payload);                             
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async deleteAwareness({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/awareness/${payload}`);
                commit('deleteAwareness', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async deleteLoyalty({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/loyalty/${payload}`);
                commit('deleteMediaCoverage', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async calculateAwareness({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/awareness/calculate/${payload.gameId}?round=${payload.round}`);
                if (result) {
                   const awareness = await result.data 
                   commit('loadAwareness', awareness)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async calculateLoyalty({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/loyalty/calculate/${payload.gameId}?round=${payload.round}`);
                if (result) {
                   const loyalty = await result.data 
                   commit('loadLoyalty', loyalty)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async awarenessTransition({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                await http.get(`/awareness/transition/${payload.gameId}?round=${payload.round}`);            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async loyaltyTransition({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                await http.get(`/loyalty/transition/${payload.gameId}?round=${payload.round}`);              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
    },
    getters: {
        awareness (state) {
            return state.awareness;
        },
        loyalty (state) {
            return state.loyalty;
        }

    }
}